var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_70537)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.700195,
    y: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700195 0.25H24.7002V12.25H0.700195V0.25Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700195 12.25H24.7002V24.25H0.700195V12.25Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.700195 0.25V24.3028L12.1288 12.25L0.700195 0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82633 13.0258C6.82061 12.9378 7.55776 12.6258 7.55776 12.2498C7.55776 11.8754 6.82061 11.5618 5.82633 11.4738C5.76347 10.0818 5.54061 9.0498 5.27204 9.0498C5.00461 9.0498 4.78061 10.0818 4.71776 11.4738C3.72347 11.5618 2.98633 11.8738 2.98633 12.2498C2.98633 12.6242 3.72347 12.9378 4.71776 13.0258C4.77947 14.4178 5.00347 15.4498 5.27204 15.4498C5.53947 15.4498 5.76347 14.4178 5.82633 13.0258Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2726 13.0502C9.58819 13.0502 9.84403 12.692 9.84403 12.2502C9.84403 11.8084 9.58819 11.4502 9.2726 11.4502C8.95701 11.4502 8.70117 11.8084 8.70117 12.2502C8.70117 12.692 8.95701 13.0502 9.2726 13.0502Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55776 8.25137C3.87335 8.25137 4.12919 7.89319 4.12919 7.45137C4.12919 7.00954 3.87335 6.65137 3.55776 6.65137C3.24217 6.65137 2.98633 7.00954 2.98633 7.45137C2.98633 7.89319 3.24217 8.25137 3.55776 8.25137Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55776 17.85C3.87335 17.85 4.12919 17.4918 4.12919 17.05C4.12919 16.6082 3.87335 16.25 3.55776 16.25C3.24217 16.25 2.98633 16.6082 2.98633 17.05C2.98633 17.4918 3.24217 17.85 3.55776 17.85Z",
    fill: "#959595"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_70537"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.700195,
    y: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/Philippines.e539d23ce26a1de6000f6c0c7fafd16c.svg";
export { ForwardRef as ReactComponent };